import styled from 'styled-components'
import ToggleSwitchBase from 'components/toggle-switch'

export const ToggleSwitch = styled(ToggleSwitchBase)`
    margin-block-start: 24px;
`